export default __webpack_public_path__ + "c0977839b904ecd1e4ab0d2b1fd46c3d.png";